import axios from 'axios';
import apiClient from './apiClient';

export type AdminRole = 'SUPER_ADMIN' | 'LECTURA';

export interface User {
  id: number;
  email?: string | null;
  name: string;
  surname: string;
  profile: string;
  admin_role?: AdminRole | null;
  is_superuser: boolean;
  approver_id?: number | null;
  preferred_language?: string | null;
}

interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
  user: User;
}

const baseURL = process.env.REACT_APP_API_BASE_URL || '/api';

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await axios.post(`${baseURL}/auth/login`, { email, password });
    return response.data;
  },

  async getCurrentUser(): Promise<User> {
    const token = localStorage.getItem('access_token');
    const response = await axios.get(`${baseURL}/auth/me`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  },

  async logout(): Promise<void> {
    try {
      const token = localStorage.getItem('access_token');
      await axios.post(`${baseURL}/auth/logout`, {}, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
    } catch {
      // ignore
    }
  },

  getAccessToken(): string | null {
    return localStorage.getItem('access_token');
  },

  async updateMyProfile(data: { preferred_language?: string }): Promise<User> {
    const token = localStorage.getItem('access_token');
    const response = await axios.patch(`${baseURL}/auth/me`, data, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  },
};

export interface AdminUserListItem {
  id: number;
  email: string | null;
  name: string;
  surname: string;
  profile: string;
  admin_role: string | null;
  approver_id: number | null;
  approver_name: string | null;
  is_active: boolean;
}

export const usersApi = {
  list: () => apiClient.get<AdminUserListItem[]>('/auth/users').then((r) => r.data),
  create: (data: { email: string; name: string; surname: string; password: string; profile?: string; admin_role?: string; approver_id?: number | null }) =>
    apiClient.post<AdminUserListItem>('/auth/users', data).then((r) => r.data),
  update: (id: number, data: { email?: string; name?: string; surname?: string; password?: string; profile?: string; admin_role?: string; approver_id?: number | null; is_active?: boolean }) =>
    apiClient.put<AdminUserListItem>(`/auth/users/${id}`, data).then((r) => r.data),
};

export default authService;
